import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Sleeve} from '../models';

@Injectable()
export class SleeveService extends IoService {
  protected model = Sleeve;
  protected listUrl = '/sleeves/';
}
